
























































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { getSetting, setSetting } from "@/services/autoSettings/autoSettingsService";
// components
import CreatePostContextMenu from "@/components/channels/CreatePostContextMenu.vue";
import ChannelAddPostModal from "@/components/channels/modals/ChannelAddPostModal.vue";
import ChannelAddHtmlPostTemplateModal from "@/components/channels/modals/ChannelAddHtmlPostTemplateModal.vue";
import ChannelAddCustomPostTemplateModal from "@/components/channels/modals/ChannelAddCustomPostTemplateModal.vue";
// types
import { Channel } from "@/services/channels/types";
// service methods
import { getFavorites, getRecent } from "@/services/channels/channelsService";
import { PermitionEnum, HavePermition } from "@/components/security/Permitions";
import { getAllContentTemplateSizes } from "@/services/contentTemplates/contentTemplateService";

const namespace: string = "authentication";

@Component({
    components: {
        "create-item-menu": CreatePostContextMenu,
        "channel-add-post-modal": ChannelAddPostModal,
        "channel-add-html-post-template-modal": ChannelAddHtmlPostTemplateModal,
        ChannelAddCustomPostTemplateModal
    }
})
export default class SuggestedChannels extends Vue {
    @Getter("getCurrentUser", { namespace }) getCurrentUser: any;

    // local state
    favoriteChannels = [] as Channel[];
    recentChannels = [] as Channel[];
    selectedChannelId = "";
    selectedItemTypes = [] as string[];
    componentsAutoSettingKey = "dashboardHomeWidget"
    key = "";

    permitionEnum = PermitionEnum;
    havePermition = HavePermition;
    // lifecycle hooks
    mounted() {
        this.fetchData();
    }

    // methods
    setDropdown(key: string) {
        this.key = key;
        setSetting(this.componentsAutoSettingKey, key);
    }

    fetchData() {
        const autoSettingsValue = getSetting(this.componentsAutoSettingKey);
        getFavorites().then(response => {
            this.favoriteChannels = response;
            if (autoSettingsValue === undefined || autoSettingsValue === "") {
                if (this.favoriteChannels.length > 0) {
                    this.key = "favorite";
                } else {
                    this.key = "recent";
                }
            } else {
                this.key = autoSettingsValue;
            }
        });

        getRecent().then(response => {
            this.recentChannels = response;
        });
    }

    channelSettings(channelId: string) {
        if (this.havePermition(this.getCurrentUser.permissions, this.permitionEnum[this.permitionEnum.AdminPrivilege])) {
            this.$router.push({
                name: "updatechannel",
                params: { channelId: channelId }
            });
        } else {
            this.$router.push({
                name: "editorupdatechannel",
                params: { channelId: channelId }
            });
        }
    }

    isOverflowing(index: number, type: string) {
        let refName = "" as string;
        if (type === "favorite") {
            refName = `favoriteChannelName-${index}`;
        } else if (type === "recent") {
            refName = `recentChannelName-${index}`;
        } else {
            return false;
        }
        const elements = this.$refs[refName] as HTMLElement[];
        if (elements && elements.length > 0) {
            const element = elements[0];
            return element.scrollWidth > element.clientWidth;
        }
        return false;
    }

    // events
    onOpenItemsModal(data:any) {
        this.selectedChannelId = data.channelId;
        this.selectedItemTypes = data.selectedItemTypes;
        (this.$refs.channelAddItemModal as any).open();
    }

    async onOpenHtmlItemModal(channelId: string, postType: string) {
        const sizes = await getAllContentTemplateSizes();
        this.selectedChannelId = channelId;

        (this.$refs.htmlItemTemplatesModal as any).open(true, sizes, postType);
    }

    async onOpenCustomItemModal(channelId: string, postType: string) {
        const sizes = await getAllContentTemplateSizes();
        this.selectedChannelId = channelId;

        if (sizes.filter(x => x.type.toLowerCase() !== "fixedhtml").length > 0) {
            (this.$refs.customItemTemplatesModal as any).open(true, sizes, postType);
            return;
        }
        await this.$router.push({
            name: "createPost",
            params: {
                channelId: this.selectedChannelId,
                postType: "html"
            }
        });
    }
}
